import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryLightingIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-lighting"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M16.8955 19.322H7.97602C7.15753 19.322 6.4939 19.9855 6.4939 20.8041V21.9506H18.3776V20.8041C18.3776 19.9855 17.7141 19.322 16.8955 19.322Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M11.436 19.3219H13.4355V10.9883H11.436V19.3219Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M15.3716 14.47H15.9305V10.9883H15.3716V14.47Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M16.5961 14.9348C16.5961 15.4568 16.1729 15.88 15.6509 15.88C15.1289 15.88 14.7056 15.4568 14.7056 14.9348C14.7056 14.4128 15.1289 13.9896 15.6509 13.9896C16.1729 13.9896 16.5961 14.4128 16.5961 14.9348Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M7.00401 11.9658H17.8688C18.5382 11.9658 19.0198 11.4019 18.8316 10.8388L16.0887 2.63232C15.9634 2.25747 15.5713 2 15.1259 2H9.81977C9.37694 2 8.98654 2.25444 8.85896 2.62616L6.0432 10.8326C5.84947 11.3973 6.33159 11.9658 7.00401 11.9658Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryLightingIcon.displayName = 'CategoryLightingIcon';
